import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import axios from 'axios';
export default {
  mixins: [popUp],
  props: ['eventId'],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        event_id: '',
        count: '',
        length: ''
      },
      isShowLot: false,
      rules: {
        length: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        count: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("data==", data);
                _this.formData.event_id = _this.eventId;

                if (data) {
                  _this.isShowLot = true;
                  _this.formData.regenerate = true;
                } else {
                  _this.isShowLot = false;
                }

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var data = JSON.parse(JSON.stringify(_this2.formData));

                    _this2.$api.codeGenerate(data).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success(_this2.formData.id ? '修改成功' : '添加成功');

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};